import { NoInfoDataBlock } from "./NoInfoDataBlock";
import { AnalyzeAllBtn } from "../ui/buttons";

type Props = {
  campaign_id: string;
  totalAccounts: number;
};

export const NoAnalysedDataBlock = ({ campaign_id, totalAccounts }: Props) => {
  return (
    <NoInfoDataBlock
      campaign_id={campaign_id}
      totalAccounts={totalAccounts}
      title="No completed analysis yet"
      description="All statistics will appear as soon as at least one company analysis is ready"
      buttonText="Analize Accounts"
      onClick={() => {}}
      btnBlock={<AnalyzeAllBtn campaign_id={campaign_id} />}
    />
  );
};
